import useMountEffect from '@restart/hooks/useMountEffect';
import { useDispatch } from 'react-redux';

import actions from '@/actions';
import EventEmitter from '@/libs/EventEmitter';

const usePingListener = (robotId) => {
  const dispatch = useDispatch();

  useMountEffect(() => {
    const token = EventEmitter.subscribe(`${robotId}/event/ping`, (data) => {
      dispatch(actions.robotStatus.set(robotId, data));
    });

    return () => {
      EventEmitter.unsubscribe(token);
    };
  });
};

export default usePingListener;
